var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('User',{attrs:{"form":_vm.form,"returnLink":'/#/home/company',"companyName":_vm.companyName,"timeZones":_vm.timeZones},on:{"userSubmitted":_vm.userSubmitted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }